import e from"styled-components";const t=e.div`
	display: flex;
	gap: 4px;
	align-items: center;

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type='number'] {
		-moz-appearance: textfield;
		appearance: textfield;
	}
`,r=e.div`
	display: grid;
	grid-template-columns: ${({numberOfItems:e})=>`repeat(${e}, 1fr)`};
	background-color: ${({theme:e})=>e.bg.primary};
	border-radius: 8px;
	padding: 4px;
	gap: 2px;
	width: 100%;
`,i=e.button`
	height: 32px;
	background-color: ${({isSelected:e,theme:t})=>e?t.border.black15:"transparent"};
	color: ${({theme:e})=>e.text.title};
	border-radius: 4px;
	display: grid;
	place-content: center;
	font-size: 12px;
	cursor: pointer;
	border: none;

	svg {
		fill: ${({theme:e})=>e.text.title};

		path {
			fill: ${({theme:e})=>e.text.title};
		}

		rect {
			fill: ${({theme:e})=>e.text.title};
		}
	}
`,n=e.input`
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	align-content: baseline;
	border-radius: 8px;
	border: 1px solid ${({theme:e})=>e.border.black15};
	text-align: center;
	background-color: ${({theme:e})=>e.bg.general};
	color: ${({theme:e})=>e.text.title};

	&:focus {
		outline: none;
	}
`;export{t as ButtonGroupContainer,i as GroupButton,r as GroupButtonContainer,n as GroupInput};
